export default __webpack_public_path__ + "static/media/ic_send.194d1675.svg";